import { WidgetView } from 'common';

/**
 * Return the sources configured for a widget.
 *
 * Live collections are observations made while the public widget is used and
 * can be stale. They must not replace the sources saved in the widget config.
 */
export function getSourceNames(widget: WidgetView): string[] {
  return widget.settings.default_sources?.collection_namelist?.length
    ? widget.settings.default_sources.collection_namelist
    : widget.settings.default_sources?.product_namelist ?? [];
}
